import React from 'react';
import DefaultButton from '../../../../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';

function BookingNavigationButtons({
  handleNextStep,
  activeStep,
  isNextDisabled,
  lastStep,
}) {
  const { isNextDisabled: isDisabled } = useBooking();
  const { trans } = useTranslation();
  return (
    <div className="flex gap-[10px]">
      <DefaultButton
        className="flex-[7] p-3 lg:p-[19px] text-base font-bold flex items-center justify-center"
        onClick={handleNextStep}
        disabled={isNextDisabled || isDisabled}
      >
        {activeStep === lastStep ? trans('confirm') : trans('next')}
      </DefaultButton>
    </div>
  );
}

export default BookingNavigationButtons;
